
import './star-rating.css';

import angular from 'angular';

import starRating from './star-rating';

export default angular.module('directive.star-rating', [])
	.directive('starRating', starRating)
	.name;



// WEBPACK FOOTER //
// ./src/directive/star-rating/index.js